import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import CCService from "../../services/httpServiceWithoutSuperAdmin";
import AheadEventForm from "./EventForm";

export default function AheadEventsPage() {
  const services = new CCService();
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [columns, setColumns] = useState(1);
  const [initialData, setInitialData] = useState(null);

  // Responsive columns: 1 (<768), 2 (<1024), 3 (>=1024)
  useEffect(() => {
    function updateCols() {
      const w = window.innerWidth;
      if (w < 768) setColumns(1);
      else if (w < 1024) setColumns(2);
      else setColumns(3);
    }
    updateCols();
    window.addEventListener("resize", updateCols);
    return () => window.removeEventListener("resize", updateCols);
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await services.get("/ahead/event-types");
        // Support both: service returning res or res.data
        const data = response?.data ?? response;
        setEvents(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  // Inline styles
  const containerStyle = {
    padding: 16,
    fontFamily: "Inter, Roboto, sans-serif",
  };
  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  };
  const titleStyle = { fontSize: 24, fontWeight: 700, margin: 0 };
  const newBtnStyle = {
    padding: "8px 16px",
    backgroundColor: "#4F46E5", // indigo-600
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(79,70,229,0.15)",
  };

  const gridStyle = {
    display: "grid",
    gap: 16,
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
  };

  const cardBaseStyle = {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 12,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    transition: "box-shadow 200ms ease, transform 150ms ease",
    cursor: "default",
  };

  const cardHoverStyle = {
    boxShadow: "0 6px 18px rgba(15,23,42,0.12)",
    transform: "translateY(-4px)",
  };

  const titleCardStyle = { fontSize: 16, fontWeight: 600, margin: 0 };
  const descStyle = { fontSize: 14, color: "#4B5563", marginTop: 8 };
  const metaStyle = { fontSize: 12, color: "#6B7280", marginTop: 8 };

  // Modal content wrapper for centering
  const modalWrapperStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "white",
    borderRadius: 10,
    padding: 20,
    maxWidth: "90vw",
    width: 720,
    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
    outline: "none",
  };

  const handleEdit = (e) => {
    setInitialData(e);
    setOpen(true);
  };

  useEffect(() => {
    if (!open) {
      setInitialData(null);
    }
  }, [open]);

  // simple Card component to manage hover
  function Card({ children }) {
    const [hover, setHover] = useState(false);
    return (
      <div
        style={{ ...cardBaseStyle, ...(hover ? cardHoverStyle : {}) }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {children}
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={titleStyle}>Events</h1>
        <button onClick={() => setOpen(true)} style={newBtnStyle}>
          + New Event
        </button>
      </div>

      <div style={gridStyle}>
        {events.map((e) => (
          <div onClick={() => handleEdit(e)}>
            <Card key={e.id}>
              <h3 style={titleCardStyle}>{e.title}</h3>
              <p style={descStyle}>{e.short_description}</p>
              <p style={metaStyle}>
                Status: {e.status} • Date:{" "}
                {e.start_time
                  ? new Date(e.start_time).toLocaleDateString()
                  : "—"}
              </p>
            </Card>
          </div>
        ))}
      </div>

      <Modal open={open} onClose={() => setOpen(false)}>
        <div style={modalWrapperStyle}>
          <AheadEventForm
            initialData={initialData}
            onSuccess={(data) => {
              setOpen(false);
              setEvents((prev) => {
                if (initialData?.id) {
                  return prev.map((e) => (e.id === initialData.id ? data : e));
                } else {
                  return [...prev, data];
                }
              });
            }}
          />
        </div>
      </Modal>
    </div>
  );
}
